import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/logo.png'


const _withScopeId = n => (_pushScopeId("data-v-9723affe"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "header__logo-image",
  src: _imports_0
}, null, -1))
const _hoisted_2 = { class: "header__menu" }
const _hoisted_3 = { class: "header__theme-switcher" }

import { useRoute } from 'vue-router';
import { NLayoutHeader, NMenu } from 'naive-ui';

import ThemeSwitcher from '@/components/ThemeSwitcher.vue';
import { currentRouteName, navOptions } from '@/helpers/navigation';
import { RouteName } from '@/router/types';


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const route = useRoute();
const activeKey = currentRouteName(route);

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_unref(NLayoutHeader), {
    class: "header",
    bordered: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_RouterLink, {
        class: "header__logo",
        to: { name: _unref(RouteName).HOME }
      }, {
        default: _withCtx(() => [
          _hoisted_1
        ]),
        _: 1
      }, 8, ["to"]),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(NMenu), {
          mode: "horizontal",
          value: _unref(activeKey),
          options: _unref(navOptions)
        }, null, 8, ["value", "options"]),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(ThemeSwitcher)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})